<main class="asset-upload-dialog" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary="body">
    <!-- Header -->
    <div class="dialog-header" cdkDragHandle>
        <div class="header-left">
            <mat-icon class="header-icon">{{ isEdit ? 'edit' : 'cloud_upload' }}</mat-icon>
            <h3>{{ isEdit ? 'Edit Asset' : 'Upload Asset' }}</h3>
        </div>
        <div class="header-actions">
            <button class="btn-close-dialog" (click)="close()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>

    <!-- Content -->
    <div class="dialog-content">
        <!-- File Preview -->
        <div class="file-preview">
            <div class="file-icon">
                <mat-icon>image</mat-icon>
            </div>
            <div class="file-info">
                <span class="file-name">{{ data.file.name }}</span>
                <span class="file-size">{{ formatFileSize(data.file.size) }}</span>
            </div>
        </div>

        <form [formGroup]="metadataForm" #assetForm="ngForm">
            <!-- Display Name -->
            <div class="field-group">
                <label class="field-label required">Display Name</label>
                <mat-form-field appearance="outline" class="w-100">
                    <mat-icon matPrefix>label</mat-icon>
                    <input matInput type="text" formControlName="displayName" 
                        placeholder="Enter a descriptive name..." autocomplete="off" />
                </mat-form-field>
                <p class="field-hint">A human-readable name to identify this asset</p>
            </div>

            <!-- Description -->
            <div class="field-group">
                <label class="field-label">Description</label>
                <mat-form-field appearance="outline" class="w-100">
                    <mat-icon matPrefix>notes</mat-icon>
                    <textarea matInput formControlName="description" rows="2"
                        placeholder="Optional description..."></textarea>
                </mat-form-field>
            </div>

            <!-- Tags -->
            <div class="field-group">
                <label class="field-label">Tags</label>
                <div class="tags-container">
                    <div class="tags-list" *ngIf="tags.length > 0">
                        <span class="tag-chip" *ngFor="let tag of tags">
                            {{ tag }}
                            <button type="button" class="tag-remove" (click)="removeTag(tag)">
                                <mat-icon>close</mat-icon>
                            </button>
                        </span>
                    </div>
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-icon matPrefix>sell</mat-icon>
                        <input matInput type="text" [(ngModel)]="tagInput" [ngModelOptions]="{standalone: true}"
                            (keydown)="onTagKeydown($event)" placeholder="Type a tag and press Enter..." />
                    </mat-form-field>
                </div>
                <p class="field-hint">Press Enter or comma to add tags</p>
            </div>

            <!-- Alt Text -->
            <div class="field-group">
                <label class="field-label">Alt Text</label>
                <mat-form-field appearance="outline" class="w-100">
                    <mat-icon matPrefix>accessibility</mat-icon>
                    <input matInput type="text" formControlName="altText" 
                        placeholder="Describe the image for accessibility..." />
                </mat-form-field>
                <p class="field-hint">Used for screen readers and email accessibility</p>
            </div>
        </form>
    </div>

    <!-- Footer -->
    <div class="dialog-footer">
        <div class="footer-left"></div>
        <div class="footer-right">
            <button class="btn-cancel" (click)="close()">
                <mat-icon>close</mat-icon>
                <span>Cancel</span>
            </button>
            <button class="btn-upload" (click)="submit()" [disabled]="metadataForm.invalid">
                <mat-icon>{{ isEdit ? 'save' : 'cloud_upload' }}</mat-icon>
                <span>{{ isEdit ? 'Save Changes' : 'Upload Asset' }}</span>
            </button>
        </div>
    </div>
</main>

